export const LogoMark = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <circle cx="16" cy="16" r="14" stroke="#00FF66" strokeOpacity="0.18" strokeWidth="1.5" />
    <circle cx="16" cy="16" r="10" stroke="#00FF66" strokeOpacity="0.4" strokeWidth="1.5" />
    <circle cx="16" cy="16" r="6" fill="#00FF66" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="inline-flex items-center gap-2.5 select-none">
    <LogoMark />
    <span className={`font-display font-800 tracking-tight text-lg ${light ? "text-ink" : "text-white"}`} style={{ fontWeight: 800 }}>
      Jiggly
    </span>
  </span>
);

export default Logo;
